import { createFileRoute } from "@tanstack/react-router";
import { getCheckins } from "~/fetch/checkins";
import { CardsPage } from "~/components/CardsPage";

export const Route = createFileRoute('/country/$id/page/$page')({
  component: Component,
  loader: ({ params }) => {
    const page = parseInt(params.page || '1', 10);
    return getCheckins({ data: { page, group: 'country', groupValue: params.id } });
  },
});

function Component() {
  const data = Route.useLoaderData();
  return <CardsPage data={data} />;
}
